module.exports = __webpack_public_path__ + "election-2026-c8427ed7ad9eb7990e8c.svg";